module.exports = __webpack_public_path__ + "static/fipcpinkfloral4-8434461c307ea771dca7c51a0035f7c7.jpeg";